import { Injectable, inject } from '@angular/core';
import { CommonsHttpService } from '@qaroni-core/services/commons/commons-http/commons-http.service';
import { AssessmentCompetencyGraphicResult } from '@qaroni-shared/types/assessment-competency-graphic-result';
import { AssessmentCompetencyGraphicResultApiResponse } from '@qaroni-shared/types/assessment-competency-graphic-result-response';
import { Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AssessmentGraphicsResultsHttpService } from './assessment-graphics-results-http.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentGraphicsResultsService {
  private http = inject(AssessmentGraphicsResultsHttpService);
  private commonHttp = inject(CommonsHttpService);

  private assessmentTypeCompetenciesResultsSubject = new Subject<
    AssessmentCompetencyGraphicResult[]
  >();

  public getAssessmentTypeCompetenciesResultsSubject$() {
    return this.assessmentTypeCompetenciesResultsSubject
      .asObservable()
      .pipe(shareReplay(1));
  }

  public assessmentTypeCompetenciesResults(
    companyID: number,
    assessmentID: number,
    employeeID: number
  ) {
    this.http
      .assessmentTypeCompetenciesResults$(companyID, assessmentID, employeeID)
      .subscribe({
        next: this.nextAssessmentTypeCompetenciesResults,
        error: this.errorAssessmentTypeCompetenciesResults,
      });
  }

  private nextAssessmentTypeCompetenciesResults = (
    response: AssessmentCompetencyGraphicResultApiResponse
  ) => {
    if (this.commonHttp.validationsHttp.verifyStatus200(response)) {
      this.assessmentTypeCompetenciesResultsSubject.next(response.body.result);
    } else {
      this.assessmentTypeCompetenciesResultsSubject.next(null);
    }
  };

  private errorAssessmentTypeCompetenciesResults = () => {
    this.assessmentTypeCompetenciesResultsSubject.next(null);
  };

  public responsableEmployeeEvaluationTypeResults(
    employeeID: number,
    evaluationID: number,
    responsableID: number
  ) {
    this.http
      .responsableEmployeeEvaluationTypeResults$(
        employeeID,
        evaluationID,
        responsableID
      )
      .subscribe({
        next: this.nextAssessmentTypeCompetenciesResults,
        error: this.errorAssessmentTypeCompetenciesResults,
      });
  }

  public employeeEvaluationTypeResults(
    employeeID: number,
    evaluationID: number
  ) {
    this.http
      .employeeEvaluationTypeResults$(employeeID, evaluationID)
      .subscribe({
        next: this.nextAssessmentTypeCompetenciesResults,
        error: this.errorAssessmentTypeCompetenciesResults,
      });
  }
}
